import {useState} from 'react';
import { getScaleValues } from '../utils/scoringScale';
import { NOT_APPLICABLE_LABEL } from '../utils/scoreState';

export const getCareSummaries = () => {
    return [
        {
            dateOfPlan: '21 April 2022',
            typeOfPlan: 'Interdisciplinary',
            typeOfMeeting: 'Weekly Conference Rounds',
            author: 'Last, First',
            position: 'Position',
        },
        {
            dateOfPlan: '21 April 2022',
            typeOfPlan: 'Interdisciplinary',
            typeOfMeeting: 'Discharge Planning',
            author: 'Last, First',
            position: 'Position',
        },
        {
            dateOfPlan: '21 April 2022',
            typeOfPlan: 'Interdisciplinary',
            typeOfMeeting: 'Weekly Conference Rounds',
            author: 'Last, First',
            position: 'Position',
        },
        {
            dateOfPlan: '21 April 2022',
            typeOfPlan: 'Individual',
            typeOfMeeting: '',
            author: 'Last, First',
            position: 'Position',
        },
    ]
}

export const getIssues = () => {
    return [
        {
            id: 1,
            name: 'Energy and Drive'
        },
        {
            id: 2,
            name: 'Emotional Function'
        },
        {
            id: 3,
            name: 'Sensation of Pain'
        },
        {
            id: 1,
            name: 'Exercise Tolerance'
        },
    ]
}

// The options a score picker offers for one heading: every value its scoring
// scale defines, plus an explicit N/A. Called with no scale — from a screen
// that has no heading in hand — it falls back to the default 1-5 scale, which
// is what a heading that names none is scored on.
export const getScore = (scale) => {
    const options = getScaleValues(scale).map((value, index) => ({
        id: index + 1,
        value,
    }));
    return [...options, { id: options.length + 1, value: NOT_APPLICABLE_LABEL }];
}

export const getIntervention = () => {
    return [
        {
            id: 1,
            name: 'Assessment',
            intervention: 'Diagnostic'
        },
        {
            id: 2,
            name: 'Monitoring',
            intervention: 'Diagnostic'
        },
        {
            id: 3,
            name: 'Manual therapy',
            intervention: 'Therapeutic'
        },
        {
            id: 4,
            name: 'Accupuncture',
            intervention: 'Therapeutic'
        },
        {
            id: 5,
            name: 'Training',
            intervention: 'Therapeutic'
        },
        {
            id: 6,
            name: 'Exercise',
            intervention: 'Therapeutic'
        },
        {
            id: 7,
            name: 'Education',
            intervention: 'Therapeutic'
        },
        {
            id: 8,
            name: 'Counselling',
            intervention: 'Therapeutic'
        },
        {
            id: 9,
            name: 'Psychotherapy',
            intervention: 'Therapeutic'
        },
        {
            id: 10,
            name: 'Prescription',
            intervention: 'Therapeutic'
        },
        {
            id: 11,
            name: 'Referral',
            intervention: 'Therapeutic'
        },
    ]
}

export const getPosition = () => {
    return [
        {
            id: 1,
            name: 'Case Manager (CM)'
        },
        {
            id: 2,
            name: 'Dietician (Diet)'
        },
        {
            id: 3,
            name: 'Kinesiologist (Kin)'
        },
        {
            id: 4,
            name: 'Nurse (Nur)'
        },
        {
            id: 5,
            name: 'Nurse Practitioner (NP)'
        },
        {
            id: 6,
            name: 'Occupational Therapist (OT)'
        },
        {
            id: 7,
            name: 'Pharmacist (Pharm)'
        },
        {
            id: 8,
            name: 'Physician',
            categories: [
                {
                    id: 1,
                    name: 'Family Doctor (MD-Fam)'
                },
                {
                    id: 2,
                    name: 'Orthopedic Surgeon (MD-Ortho)'
                },
                {
                    id: 3,
                    name: 'Psychiatrist (MD-Psych)'
                },
            ]
        },
        {
            id: 9,
            name: 'Physician Assistant (PA)',
        },
        {
            id: 10,
            name: 'Physiotherapist (Physio)',
        },
        {
            id: 10,
            name: 'Psychologist (Psych)',
        },
        {
            id: 11,
            name: 'Social Worker (SW)',
        },
        {
            id: 12,
            name: 'Family Member (Fam)',
        },
        {
            id: 12,
            name: 'Patient (Pt)',
        },
    ]
}

export const getProvider = () => {
    return [
        {
            id: 1,
            name: 'Last, First (position)'
        },
        {
            id: 2,
            name: 'Last, First (position)'
        },
        {
            id: 3,
            name: 'Last, First (position)'
        },
    ]
}

const FunctionIssues = () => {
    const [functionIssue, setFunctionIssue] = useState([
        {
            id: 1,
            intervention: [1]
        } 
    ])

    return {functionIssue, setFunctionIssue};
}

export default FunctionIssues;